<template>
  <BaseModal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_translations.value.modal_purchase_success_title }}</h1>

      <BaseImage
        src="/static/images/store/store_successful_icon.svg"
        alt="success icon"
        class="top_img"
      />

      <p class="mt-40"><b>{{ $_translations.value.modal_purchase_success_result }}</b></p>

      <p class="games-to-price"><span>{{ quantityText }}</span> {{ $_translations.value.modal_purchase_success_items_unlocked }}</p>

      <p>{{ $_translations.value.modal_purchase_success_play_new_game }}</p>

      <BaseButton @click:button="$emit('start:newGame')">
        {{ $_translations.value.modal_purchase_success_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';

defineEmits(['start:newGame']);

defineProps({
  quantityText: {
    type: String,
    default: '',
  },
});
</script>
